<template>

    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs type="a"
                :pages="[
                           {
                               name: $tc('messages.question_batch_imports', 2),
                               href: meta.links.index
                           },{
                               name: $t('messages.edit'),
                               href: null
                           },
                       ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title"/>
                            <FormInput  id="title" v-model="form.title" name="title" type="text" max="191" class="mt-1"/>
                            <FormError :value="form.errors.title" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.user_id')" for="user_id"/>
                            <FormSelect required id="user_id" v-model="form.user_id" :options="options.users" class="mt-1"/>
                            <FormError :value="form.errors.user_id" class="mt-2"/>
                        </div>
                    </div>

                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>

        </form>

    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'questionBatchImport'],
    data() {
        return {
            form: this.$inertia.form({
                title: this.questionBatchImport.title,
                user_id: this.questionBatchImport.user_id,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
